module.exports = __webpack_public_path__ + "img/headLeft6.63d7cd6a.png";